import { Component, OnInit } from '@angular/core';
import { RestService } from '../../services/rest.service';
import { HelpersService } from '../../services/helpers.service';
import { Router } from '@angular/router';
import { ActivatedRoute } from '@angular/router';
import { DatePipe } from '@angular/common';
import { AuthService } from '../../services/auth.service';

const Supplier = 'supplier';

@Component({
  selector: 'app-user-management',
  templateUrl: './user-management.component.html',
  styleUrls: ['./user-management.component.scss'],
  providers: [DatePipe],
})
export class UserManagementComponent implements OnInit {
  public data: any;
  public user_data: any;
  blotterType = 'distributor';
  private gridApi;
  private gridColumnApi;
  constructor(private auth: AuthService, private rest: RestService, private helpers: HelpersService, private router: Router, private datePipe: DatePipe, private route: ActivatedRoute) {
  }

  public distributor_column_defs = [
    { headerName: 'Distributor Entity', field: 'legal_name' },
    { headerName: 'Email', field: 'email' },
    { headerName: 'First Name', field: 'first_name' },
    { headerName: 'Last Name', field: 'last_name' },
    { headerName: 'Phone', field: 'phone_number' },
    { headerName: 'Title', field: 'title' },
    { headerName: 'Permission Level', field: 'user_permissions' },
    { headerName: 'Active User', field: 'active', valueFormatter: this.activeUser, cellStyle: this.helpers.greenOrRed },
    { headerName: 'Agreed to Terms', field: 'agreed_to_terms', valueFormatter: this.termsAgree, cellStyle: this.helpers.blackOrRed },
    { headerName: 'Cognito Integrated', field: 'hasCognito', tooltipField: 'uuid', valueFormatter: this.termsAgree, cellStyle: this.helpers.blackOrRed },
    { headerName: 'Date Created', field: 'created_date' },
    { headerName: 'Last Updated', field: 'last_updated', valueFormatter: this.helpers.adminFormatDate},

  ];

  public supplier_column_defs = [
    { headerName: 'Supplier Entity', field: 'legal_name' },
    { headerName: 'Email', field: 'email' },
    { headerName: 'First Name', field: 'first_name' },
    { headerName: 'Last Name', field: 'last_name' },
    { headerName: 'Phone', field: 'phone_number' },
    { headerName: 'Title', field: 'title' },
    { headerName: 'Permission Level', field: 'user_permissions' },
    { headerName: 'Active User', field: 'active', valueFormatter: this.activeUser, cellStyle: this.helpers.greenOrRed },
    { headerName: 'Agreed to Terms', field: 'agreed_to_terms', valueFormatter: this.termsAgree, cellStyle: this.helpers.blackOrRed },
    { headerName: 'Cognito Integrated', field: 'hasCognito', tooltipField: 'uuid', valueFormatter: this.termsAgree, cellStyle: this.helpers.blackOrRed },
    { headerName: 'Date Created', field: 'created_date' },
    { headerName: 'User Type', field: 'user_type' },
    { headerName: 'Last Updated', field: 'last_updated', valueFormatter: this.helpers.adminFormatDate}
  ];

  public inblock_column_defs = [
    { headerName: 'Email', field: 'email' },
    { headerName: 'Permission Level', field: 'user_permissions' },
    { headerName: 'Active User', field: 'active', valueFormatter: this.activeUser, cellStyle: this.helpers.greenOrRed },
    { headerName: 'Agreed to Terms', field: 'agreed_to_terms', valueFormatter: this.termsAgree, cellStyle: this.helpers.blackOrRed },
    { headerName: 'Cognito Integrated', field: 'hasCognito', tooltipField: 'uuid', valueFormatter: this.termsAgree, cellStyle: this.helpers.blackOrRed },
    { headerName: 'User Type', field: 'user_type' },
    { headerName: 'Last Updated', field: 'last_updated', valueFormatter: this.helpers.adminFormatDate}
  ];

  permissionLevel(userPermissions) {
    if (userPermissions=='admin') {
      return 'Admin';
    }
    if (userPermissions=='read') {
      return 'View Only';
    }
    if (userPermissions=='full') {
      return 'Write Access';
    }
    return '';
  }

  activeUser(flag) {
    return flag.value?'Active':'Inactive';
  }

  termsAgree(flag) {
    return flag.value?'Yes':'No';
  }

  map_user_data(data) {
    this.autoSizeColumns();
    return data.map(row => {
      return {
        id: row.id,
        email: row.email,
        user_permissions: this.permissionLevel(row.user_permissions),
        active: row.active,
        agreed_to_terms: row.agreed_to_terms,
        hasCognito: (row.uuid!='00000000-0000-0000-0000-000000000000'),
        uuid: row.uuid,
        user_type: row.user_type,
        last_updated: row.last_updated,
        legal_name: row.legal_name,
        first_name: row.first_name,
        last_name: row.last_name,
        phone_number: row.phone_number,
        created_date: row.created_date,
        title: row.title
      };
    });
  }

  ngOnInit() {
    this.route.params.subscribe((params) => this.setBlottertype(params['type']));
  }

  onGridReady(params) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
    this.autoSizeColumns();
  }

  onFirstDataRendered(params) {
    this.autoSizeColumns();
  }

  autoSizeColumns() {
    if (!this.gridColumnApi)
      return;

    var allColumnIds = [];
    this.gridColumnApi.getAllColumns().forEach(function (column) {
      allColumnIds.push(column.colId);
    });
    this.gridColumnApi.autoSizeColumns(allColumnIds);
  }

  onRowClicked(event: any) {
// TODO - user detail page?
//    this.router.navigate(['/quote', event.data.quote_id, event.data.id]);
  }

  setBlottertype(value: string) {
    if ( value === 'undefined' || !value) {
      value = 'distributor';
    }
    if (value === 'distributor') {
      this.blotterType = 'distributor';
    } else if (value === 'supplier') {
      this.blotterType = 'supplier';
    } else if (value === 'inblock') {
      this.blotterType = 'inblock';
    }
    return this.rest.getUsers(this.blotterType).subscribe(data => {
      this.data = data;
      this.user_data = this.map_user_data(data);
    });
  }

  navigateBlotterType(value: string) {
    this.router.navigate(['users/' + value]);
  }

}
